import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getWebinarArchiveRead(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getWebinarArchiveRead',
        parameter: {
            userID: action.userID,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){

        if(action.onSuccess) {
            action.onSuccess(data.count);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getWebinarArchiveRead",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getWebinarArchiveReadSaga = takeEvery('GetWebinarArchiveRead_Saga', getWebinarArchiveRead);


function* setWebinarArchiveRead(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setWebinarArchiveRead',
        parameter: {
            userID: action.userID,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess();
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setWebinarArchiveRead",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setWebinarArchiveReadSaga = takeEvery('SetWebinarArchiveRead_Saga', setWebinarArchiveRead);

function* getWebinarArchiveList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getWebinarArchiveList',
        parameter: {
            deleteFlg: action.deleteFlg
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){

        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getWebinarArchiveList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getWebinarArchiveListSaga = takeEvery('GetWebinarArchiveList_Saga', getWebinarArchiveList);